// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__rUSij","mask":"Modal_mask__oYyQE","alert":"Modal_alert__n8fif","button":"Modal_button__7Sbk5"};